<div class="jobcard-label" [ngStyle]="{color: labelColor ? labelColor : ''}">{{ label }}</div>
<div class="p-inputgroup">
  <!--    <span *ngIf="icon" class="input-icon">-->
  <!--    <daz-icon [color]="iconColor" [name]="icon"-->
  <!--              [size]="'20px'"></daz-icon>-->
  <!--    </span>-->

  <textarea #textareaRef (input)="handleInputChange($event)" [placeholder]="placeholder" [(ngModel)]="value"
    [ngClass]="{'invalid': required && !value, 'auto-grow' : autoGrow, 'rounded': rounded}"
    [disabled]="isDisabled" class="hub-input" pInputText [rows]="rows" type="text">

  </textarea>
</div>
<div class="error-message" *ngIf="required && !value">{{ errorLabel }}</div>